import { AppInsightsProvider } from '@davies-group/error-handling';
import React from 'react';
import ReactDOM from 'react-dom';

import { DocumentUploadProvider } from './context/DocumentUploadContext';
import App from './App';
import CustomRouter from './CustomRouter';
import { applicationSettings, createHistory } from './utils';

// get history
const history = createHistory();

ReactDOM.render(
    <React.StrictMode>
        <CustomRouter history={history}>
            <AppInsightsProvider instrumentationKey={applicationSettings.applicationInsightsInstrumentationKey} history={history}>
                <DocumentUploadProvider>
                    <App />
                </DocumentUploadProvider>
            </AppInsightsProvider>
        </CustomRouter>
    </React.StrictMode>,
    document.getElementById('root'),
);
